export default __webpack_public_path__ + "static/media/Elle_Tiffany_2021_04_210845_2.62be8bbe.gif";